export const MEASUREMENT_UNIT_OPTIONS = [
  {
    value: "shipments_sum_usd",
    labelKey: "promotions.measurementUnits.shipments_sum_usd",
  },
];

export const DEFAULT_MEASUREMENT_UNIT = "shipments_sum_usd";

export const PROMOTION_NAME_MAX_LENGTH = 255;

export const PROMOTION_REWARD_MAX_LENGTH = 255;

export const HEX_COLOR_PATTERN = /^#[0-9A-Fa-f]{6}$/;
